import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { getValueProperty, lastValueFrom, scrollTop } from '../../helpers/functions.helpers';

import { PhaseType } from '../../models/navigation/phase-type.model';
import { ProductProcessType } from '../../models/navigation/product-process-type.model';
import { StepType } from '../../models/navigation/step-type.model';
import { ApplicationService, EChannelId } from '../application/application.service';
/**
 * Definición de la interfaz IFlowType para establecer un modelo del flujo
 *
 * *Defines IFlowType interface to create flow model*
 *
 * @type {interface}
 */
export interface IFlowType {
  /**
   * Definición de la variable name como string, nombre del flujo
   *
   * *Defines name variable as string, flow name*
   *
   * @type {public}
   * @var {string} name
   */
  name: string;

  /**
   * Definición de la variable name como startPhase, fase inicial
   *
   * *Defines startPhase variable as string, initial phase*
   *
   * @type {public}
   * @var {string} startPhase
   */
  startPhase: string;

  /**
   * Definición de la variable totalPhases como number, número total de fases
   *
   * *Defines totalPhases variable as number, total phases*
   *
   * @type {public}
   * @var {number} totalPhases
   */
  totalPhases: number;

  /**
   * Definición de la variable phases como PhaseType[], lista de fases
   *
   * *Defines phases variable as PhaseType[], phases list*
   *
   * @type {public}
   * @var {PhaseType[]} phases
   */
  phases: PhaseType[];
}
const _url = "./assets/resources/application_flow.json";



/**
 * Clase utilizada para la navegación de la aplicación
 *
 * *Class used to navigate through the app*
 *
 * @type {class}
 */
@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  public _FlowSettings = '';

  /**
   * Inicializaión de la variable flowStructure como arreglo de ProductProcessType
   *
   * *Set flowStructure variable as ProductProcessType array*
   *
   * @access              private
   * @type                { ProductProcessType[] }
   */
  private flowStructure: ProductProcessType[] | any;

  /**
   * Inicializaión de la variable currentPhase como PhaseType
   *
   * *Set currentPhase variable as PhaseType*
   *
   * @access              private
   * @type                { PhaseType }
   */
  private currentPhase: {} | any;

  /**
   * Inicializaión de la variable currentStep como StepType
   *
   * *Set currentStep variable as StepType*
   *
   * @access              private
   * @type                { StepType }
   */
  private _currentStep: StepType | any;

  /**
   * Inicializaión de la variable currentFlow como IFlowType
   *
   * *Set currentFlow variable as IFlowType*
   *
   * @access              private
   * @type                { IFlowType }
   */
  private currentFlow: IFlowType | any;

  /**
   * Inicializaión de la variable loadExitScreen como boolean
   *
   * *Set loadExitScreen variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  loadExitScreen: boolean;

  /**
   * Inicializaión de la variable loadCustomScreen como boolean
   *
   * *Set loadCustomScreen variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  loadCustomScreen: boolean;

  /**
   * Inicializaión de la variable isGeneralInformationStep como boolean
   *
   * *Set isGeneralInformationStep variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  isGeneralInformationStep: boolean;

  /**
   * Inicializaión de la variable actualStep como boolean
   *
   * *Set actualStep variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  actualStep: string | undefined;

  /**
   * Inicializaión de la variable isGeneralInformationStep como boolean
   *
   * *Set isGeneralInformationStep variable as boolean*
   *
   * @access              private
   * @type                { boolean }
   */
  postLogin: boolean | undefined;

  /**
   * Definición de la variable storedPreviousStep, guarda el nombre de la pantalla anterior
   *
   * *Defines storedPreviousStep variable as object, store the previous step name*
   *
   * @type {private}
   * @var {string} storedPreviousStep
   */
  private _storedPreviousStep: any; // [string | undefined]; // string | undefined; //
  public _Next: any;
  public _Prev: any;

  private _applicationFlow: any;

  get storedPreviousStep(): any {
    return this._storedPreviousStep;
  }
  set storedPreviousStep(value: any) {
    this._storedPreviousStep = value;
  }

  get currentStep(): any {
    return this._currentStep;
  }
  set currentStep(value: any) {
    this._currentStep = value;
  }

  /**
   * Summary      Constructor of the component.
   *
   * @param {AbreCuentasService}          abreCuentasService          Injectable abreCuentasService service.
   * @param {ChannelCommunicatorService}  channelCommunicatorService  Injectable channelCommunicatorService service.
   * @param {RequestService}              requestService              Injectable requestService service.
   * @param {RequestService}              router                      Injectable router service.
   * @param {DaliService}                 daliService                 Injectable dali service
   * @var   {string[]}                    loadedList                  Set loadedLists as empty array
   * @var   {string[]}                    loadedConfigList            Set loadedConfigList as empty array
   * @var   {boolean}                     loadExitScreen              Set loadExitScreen as empty false
   * @var   {boolean}                     loadCustomScreen            Set loadCustomScreen as empty false
   * @var   {boolean}                     isGeneralInformationStep    Set isGeneralInformationStep as empty false
   */
  constructor(
    private router: Router,
    private _http: HttpClient,
    private app: ApplicationService
  ) {
    this.loadExitScreen = false;
    this.loadCustomScreen = false;
    this.isGeneralInformationStep = false;
    this.storedPreviousStep = [];
  }

  /**
   * Inicializa el flujo obtenido del servicio, este va a ser el flujo que va a seguir la aplicación
   *
   * *Set Up flow obtained from the service, this flow will be followed by the app*
   *
   */
  async startFlow(initialFlow: string = '', currentApp: string = '') {
    //Revisar flujo y propiedad radications
    await this.loadApplicationFlow();
    if (this.flowStructure 
      && this.flowStructure.hasOwnProperty('radications') 
      && Array.isArray(this.flowStructure.radications)
      ) {
      this.flowStructure = this.flowStructure.radications[0];

      if(initialFlow === ''){
        initialFlow = this.flowStructure.startFlow
      }
      this.currentFlow = this.flowStructure.flows[initialFlow];
      this.currentPhase = this.currentFlow
        .phases[
        this.currentFlow.startPhase
      ] as PhaseType;

      const currentPhaseStart = this.getBaseConfig(this.currentPhase.start, currentApp);

      this.currentPhase.key = this.flowStructure.flows[initialFlow].startPhase;
      this.currentStep = this.currentPhase.steps[currentPhaseStart];
      this.currentStep.key = currentPhaseStart;
      this._FlowSettings += `key   ${this.currentStep.key}\n`;
      this._FlowSettings += `es    ${this.currentStep.es}\r`;
      this._FlowSettings += `tag   ${this.currentStep.tag_name}\r`;
      this._FlowSettings += `next  ${this.getBaseConfig(this.currentStep.next, currentApp)}\n`;
      this._FlowSettings += `prev  ${this.getBaseConfig(this.currentStep.previous, currentApp)}\n`;
      this._Next = this.getBaseConfig(this.currentStep.next, currentApp);
      this._Prev = this.getBaseConfig(this.currentStep.previous, currentApp);
      this.navigateTo(currentPhaseStart);
    }
    return;
  }


  async navigateTo(route: string | any) {
    if (this.currentFlow == undefined) return;
    await this.router.navigate([route]);
    scrollTop();
    return;
  }


  /**
   *
   * @param postlogin
   * @param url
   * @returns
   */
  loadApplicationFlow(url?: any): Promise<ProductProcessType[]> {
    return new Promise(async (resolve, reject) => {
      if (!this._applicationFlow) {
        const URL = url ?? _url;
        /**
         * @see https://rxjs.dev/deprecations/to-promise
         */
        const req$ = this._http.get(URL);
        const response: any = await lastValueFrom(req$);
        if (response) {
          this.applicationFlow = response.data;
        }
        else {
          throw new Error("No es posible cargar el applicationFlow");
        }
        this.flowStructure = this._applicationFlow;
        resolve(this._applicationFlow);
      } else {
        this.flowStructure = this._applicationFlow;
        resolve(this._applicationFlow);
      }
    });


    /*url = url ?? _url;
    let _njd : Observable<ProductProcessType[]> = this._http.get<ProductProcessType[]>(url);
    let flow = firstValueFrom(_njd).then((data) => {
      this.flowStructure = data!=undefined? Array.from(Object.values(data))[0]:[];
      return data
    });
    let res = flow.then((data) => {
      this.flowStructure = data!=undefined?Array.from(Object.values(data))[0]:[];
      return data;
    });
    return res;*/


  }

  set applicationFlow(value: any) {
    this._applicationFlow = value;
  }

  /**
   *
   * @param currentApp
   * @returns
   */
  async nextStep(currentApp: string = '') {
    if (this.currentFlow == undefined) {
      await this.startFlow();
    };
    const step = this.getBaseConfig(getValueProperty(this.currentStep,'next'), currentApp);
    this.goToStep(step);
  }
  async goToStep(step: string) {
    if (step) {
      if (step === '$exit') {
        this.loadExitScreen = true;
      } else if (step === '$login-app') {
        //this.goToLoginPage();
      } else if (step.startsWith('$flow')) {
        if (step.split('/').length === 2) {
          this.goToFlowSteps(step.split('/')[1]);
        } else if (step.split('/').length === 3) {
          this.goToFlowSteps(step.split('/')[1], step.split('/')[2]);
        } else if (step.split('/').length === 4) {
          this.goToFlowSteps(
            step.split('/')[1],
            step.split('/')[2],
            step.split('/')[3],
          );
        }
      } else if (step.startsWith('$phase/')) {
        if (step.split('/').length > 2) {
          //this.changeToPhase(step.split('/')[1], step.split('/')[2]);
        } else {
          //this.changeToPhase(step.split('/')[1]);
        }
      } else if (step === '$customBack') {
        this.loadCustomScreen = true;
      } else {
        const newStep: StepType = this.currentPhase?.steps[step];
        if (newStep) {
          this.currentStep = newStep;
          this.currentStep.key = step;
          this.isGeneralInformationStep = false;
          this.navigateTo(step);
        }
      }
    }
  }

  /**
   *
   * @param flow
   * @param phase
   * @param step
   * @returns
   */
  async goToFlowSteps(flow: string, phase?: string, step?: string) {
    if (!this.flowStructure) return;
    const FLOW_STRUCTURE = this.flowStructure;

    if (FLOW_STRUCTURE && FLOW_STRUCTURE.hasOwnProperty('flows')) {
      this.currentFlow = FLOW_STRUCTURE.flows[flow];
      let selectedPhase = this.currentFlow.startPhase;
      let selectedStep =
        this.currentFlow.phases[
          this.currentFlow.startPhase
        ].start;
      if (phase && !step) {
        selectedPhase = phase;
      } else if (phase && step) {
        selectedPhase = phase;
        selectedStep = step;
      }
      this.currentPhase = this.currentFlow.phases[selectedPhase];
      if (this.currentPhase) {
        this.currentPhase.key = phase;
        this.currentStep = this.currentPhase.steps[selectedStep];
        if (this.currentStep) {
          this.currentStep.key = selectedStep;
        }
      }

      this.isGeneralInformationStep = false;
      this.navigateTo(selectedStep);
    }

    return;
  }

  /**
   * Permite regresar al paso anterior
   */
  async previousStep(currentApp: string = '') {
    const previous = this.getBaseConfig(getValueProperty(this.currentStep, 'previous'), currentApp);
    await this.goToStep(previous);
  }

  getBaseConfig(config: string | object, currentApp: string = ''){
    let result = '';
    if(typeof config === 'string'){
      result = config;
    }else{
      if(currentApp === '' && !this.app.currentApplication){
        currentApp = 'default';
      }else if(currentApp === '' && this.app.currentApplication){
        currentApp = this.app.currentApplication;
      }
      result = getValueProperty(config, currentApp, getValueProperty(config, 'default', false));
    }
    return result;
  }


}
